<div class="modal-header">
  <h5 class="modal-title" id="editUserLabel"></h5>
  <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
 <div class="card-body">
   <div class="row">
     <div class="col-lg-6">
       <label for="sedi" class="control-label col-form-label">Sede:</label>
       <ng-multiselect-dropdown [settings]="sediDropdownSettings" [placeholder]="'Sede'" id="sedi" [data]="Sedi"
                                [(ngModel)]="SelectedSede" (ngModelChange)="sedeCambiata()">
       </ng-multiselect-dropdown>
     </div>
     <div class="col-lg-12"></div>
<!--     <div class="col-sm-12 col-lg-3" >-->
<!--       <label  class="control-label col-form-label">Nominativo</label>-->
<!--       <input [(ngModel)]="item.nominativo" type="text" class="form-control">-->
<!--     </div>-->
     <div class="col-sm-12 col-lg-3" *ngIf="item.id">
       <label  class="control-label col-form-label">Indirizzo</label>
       <input [(ngModel)]="item.indirizzo" disabled type="text" class="form-control">
     </div>
<!--     <div class="col-sm-12 col-lg-3" >-->
<!--       <label  class="control-label col-form-label">CAP:</label>-->
<!--       <input [(ngModel)]="item.cap" type="text" class="form-control">-->
<!--     </div>-->
<!--     <div class="col-sm-12 col-lg-3">-->
<!--       <label  class="control-label col-form-label">Città:</label>-->
<!--       <input [(ngModel)]="item.citta" type="text" class="form-control">-->
<!--     </div>-->
<!--     <div class="col-sm-12 col-lg-3">-->
<!--       <label  class="control-label col-form-label">Provincia:</label>-->
<!--       <input [(ngModel)]="item.provincia" type="text" class="form-control">-->
<!--     </div>-->
<!--     <div class="col-sm-12 col-lg-3">-->
<!--       <label  class="control-label col-form-label">Email:</label>-->
<!--       <input [(ngModel)]="item.email" type="text" class="form-control">-->
<!--     </div>-->
<!--     <div class="col-sm-12 col-lg-3">-->
<!--       <label  class="control-label col-form-label">Telefono:</label>-->
<!--       <input [(ngModel)]="item.telefono" type="text" class="form-control">-->
<!--     </div>-->
     <div class="col-sm-12 col-lg-1">
       <label  class="control-label col-form-label">Pagato:</label>
       <input [(ngModel)]="item.pagato" type="checkbox" class="form-control">
     </div>
     <div class="col-sm-12 col-lg-1" *ngIf="environment.ProgettiAddon['francoDeposito']">
       <label  class="control-label col-form-label">Franco Deposito Klimaitalia:</label>
       <input [(ngModel)]="item.francoDeposito" type="checkbox" class="form-control">
     </div>
     <div class="col-sm-12 col-lg-3">
       <label  class="control-label col-form-label">Spedito:</label>
       <input [(ngModel)]="item.dataSpedito" type="date" class="form-control">
     </div>
     <div class="col-sm-12 col-lg-12">
       <label  class="control-label col-form-label">Note:</label>
       <textarea [(ngModel)]="item.note" type="text" class="form-control"></textarea>
     </div>

     <br>
     <div class="col-12">

     </div>
     <div class="col-12">
       <div class="card-body">
         <app-voci-di-costo
           *ngIf="item && item.voci"
           [isModifyDisabled]="false"
           [HasIva]="false"
           [HasTotale]="false"
           [HasPrezzo]="false"
           [HasProdottiDropdown]="false"
           [externalAddFunction]="true"
           [externalEditFunction]="true"
           [externalDeleteFunction]="true"
           [prezzoEditabile]="false"
           [voceEditabile]="false"
           (AddClicked)="EditVoce()"
           (UpdateClicked)="EditVoce($event)"
           (DeleteClicked)="DeleteVoce($event)"
           [CampiAggiuntivi]="[
            {nome:'Trasporto', oggetti:['spedizione'], icon:'fa-euro-sign', modificabile: true, inputType: 'number'},
            ]"
           [HasUm]="false"
           [myProp]="item"
           [title]="'Beni da spedire'"
           (resetpage)="refresh()
"></app-voci-di-costo>
       </div>
     </div>
   </div>
 </div>
</div>

<div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10" >
  <button type="submit" (click)="saveClick(true)"  class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Salva e chiudi </span>
    <i-feather name="save" class="feather-md "></i-feather>
  </button>
</div>
